import React, { useState, useEffect } from "react";
import {
  Checkbox,
  DatePicker,
  Input,
  Modal,
  Radio,
  Select,
  Tag,
  Typography,
} from "antd";
import styles from "./offerCard.module.css";
import { toast } from "react-toastify";
import { reactToast } from "../../helper";

import {
  SESSION_TYPE,
  MONTHLY_TYPE,
  DEMO_TYPE,
  STATUS_AVAILABLE,
  TEACHING_MODE,
  TEACHER_ROLE,
  RETAKE_TYPE,
} from "../../constants";
import { MdCancel } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeacherSlots } from "../../services/teacher";
import { fetchTeacherCourseData } from "../../redux/slice/teacherCourseData/teacherCourseDataThunk";
import TeacherSlots from "../teacher-slots";
import { createOfferRequest } from "../../services/offers";
import Loader from "../loader";
import { MdOutlineCancel } from "react-icons/md";
import Dropdown from "../Dropdown";
import { fetchAllSubjects } from "../../services/subjects";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { DateTime } from "luxon";
import dayjs from "dayjs";

const CreateOfferCard = ({
  open,
  handleOk,
  handleCancel,
  onSendOffer,
  studentId,
  teacherId,
  offerDetail,
  setOfferDetail,
  handleChatModalOpen,
  ...rest
}) => {
  const { Title } = Typography;
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [price, setPrice] = useState("");
  const [offerDesc, setOfferDesc] = useState("");
  const [course, setCourse] = useState("");
  const [offerRequestLoading, setOfferRequestLoading] = useState(false);
  const dispatch = useDispatch();
  const teacherCourses = useSelector((state) => state.teacherCourseData);
  const loggedInUser = useSelector((state) => state.auth.user);

  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newTemporarySubject, setNewTemporarySubject] = useState("");
  const [temporarySubjectsList, setTemporarySubjectsList] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);
  const [teachingMode, setTeachingMode] = useState(TEACHING_MODE.ONLINE);

  const [isInstantOffer, setIsInstantOffer] = useState(false);

  useEffect(() => {
    if (open) {
      getAllSubjects();
      handleResetState();
      // price will be zero if user needs a demo.
      if (
        offerDetail?.offerType === DEMO_TYPE ||
        offerDetail?.offerType === RETAKE_TYPE
      ) {
        setPrice("0");
      }
    }
    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleResetState = () => {
    setSelectedSlots([]);
    setSelectedSubjects([]);
    setTemporarySubjectsList([]);
    setSlots([]);
    setNewTemporarySubject("");
    setStartDate("");
    setEndDate("");
    setPrice("");
    setCourse("");
    setTeachingMode(TEACHING_MODE.ONLINE);
  };

  const handleSearchSlots = () => {
    // console.log("triggred click", teacherId, startDate, endDate);
    if (teacherId && startDate && endDate) {
      getTeacherSlots(teacherId, startDate, endDate);
    }
  };

  const getTeacherSlots = async (teacherId, startDate, endDate) => {
    try {
      setSlots([]);
      setSelectedSlots([]);
      setLoading(true);
      // when teacher will fetch slots then it will be logged in user
      let requestId =
        loggedInUser?.role === TEACHER_ROLE ? loggedInUser?.id : teacherId;
      const { status, data } = await fetchTeacherSlots(requestId, {
        startDate: startDate,
        endDate: endDate,
        teacherId: requestId,
      });
      if (status === 201) {
        if (data?.data?.length) {
          setSlots(data?.data);
        }
      } else {
        reactToast("error", data?.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getAllSubjects = async () => {
    try {
      const { status, data } = await fetchAllSubjects();
      if (status === 200) {
        if (data?.data?.length) {
          setAllSubjects(data?.data);
        }
      } else {
        reactToast("error", data?.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (teacherId && open) {
      dispatch(fetchTeacherCourseData(teacherId));
    }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teacherId, open]);

  const handleCloseModal = () => {
    handleCancel();
    // handleChatModalOpen();
  };

  const handleRedirectionToWallet = () => {
    handleCancel();
    // handleChatModalOpen ?? handleChatModalOpen();
    navigate("/student/wallet-summary");
  };

  const handleSlots = (e, slot) => {
    let checked = e.target.checked;
    if (
      offerDetail?.offerType !== MONTHLY_TYPE &&
      checked &&
      selectedSlots?.length
    ) {
      reactToast(
        "error",
        `You can not select more than one slot in ${offerDetail?.offerType}`
      );
      return;
    }
    if (checked) {
      let prevSelectedSlots = [...selectedSlots];
      prevSelectedSlots.push(slot);
      setSelectedSlots(prevSelectedSlots);
    } else {
      let prevSelectedSlots = [...selectedSlots];
      let filter = prevSelectedSlots?.filter(
        (item) => item?.uuid !== slot?.uuid
      );
      setSelectedSlots(filter);
    }
  };

  const getObjectsNotInArray = (arr1, arr2) => {
    const arr2Ids = new Set(arr2.map((obj) => obj?.uuid)); // Assuming objects have an 'id' property

    return arr1.filter((obj) => !arr2Ids.has(obj?.uuid));
  };

  const matchedAllSlotsLength = (currectSLot) => {
    let sameDaySlots = filterSameDaySlots(currectSLot, slots);
    let filtered = selectedSlots?.filter(
      (item) =>
        item?.dayName === currectSLot?.dayName &&
        item?.dayNameId === currectSLot?.dayNameId &&
        item?.startTime === currectSLot?.startTime &&
        item?.endTime === currectSLot?.endTime
    );
    return sameDaySlots?.length === filtered?.length;
  };

  const filterSameDaySlots = (selected, allSlots) => {
    let slots = [];

    for (let index = 0; index < allSlots.length; index++) {
      const week = allSlots[index];
      for (const [key, value] of Object.entries(week)) {
        if (value?.length) {
          for (let weekIndex = 0; weekIndex < value.length; weekIndex++) {
            const weekElement = value[weekIndex];
            if (
              weekElement?.dayNameId === selected?.dayNameId &&
              weekElement?.endTime === selected?.endTime &&
              weekElement?.startTime === selected?.startTime &&
              weekElement?.status === STATUS_AVAILABLE
            ) {
              slots.push(weekElement);
            }
          }
        }
      }
    }
    // let filterSlots = getObjectsNotInArray(slots, selectedSlots);
    // return filterSlots;
    return slots;
  };

  const handleBookAllSlotsForSameDay = (e, slot) => {
    let checked = e.target.checked;
    if (checked) {
      let prevSelectedSlots = [...selectedSlots];
      let filtered = filterSameDaySlots(slot, slots);
      let result = getObjectsNotInArray(filtered, selectedSlots);
      prevSelectedSlots.push(...result);
      setSelectedSlots(prevSelectedSlots);
    } else {
      // Only remove slots for the same dayNameId, startTime, endTime (not all days)
      let prevSelectedSlots = [...selectedSlots];
      let filtered = prevSelectedSlots?.filter(
        (item) =>
          !(
            item?.dayNameId === slot?.dayNameId &&
            item?.startTime === slot?.startTime &&
            item?.endTime === slot?.endTime
          )
      );
      setSelectedSlots(filtered);
    }
  };

  const validateOffer = (offer) => {
    if (
      offerDetail?.offerType !== DEMO_TYPE &&
      offerDetail?.offerType !== RETAKE_TYPE &&
      !selectedSubjects?.length &&
      !temporarySubjectsList?.length
    ) {
      reactToast("error", "Please add atleast one subject.");
      return false;
    }
    if (
      !offer?.slots?.length ||
      !offer?.offerType ||
      !offer?.startDate ||
      !offer?.endDate ||
      offer?.price === undefined ||
      offer?.price === null
    ) {
      reactToast("error", "Please fill all required fields.");
      return false;
    }
    if (Number(offer?.price) <= 100) {
      reactToast("error", "Offer price must be greater than 100.");
      return false;
    }
    // check if subject is selected then
    // Check if each subject has required fields
    if (
      offerDetail?.offerType !== DEMO_TYPE &&
      offerDetail?.offerType !== RETAKE_TYPE &&
      selectedSubjects?.length
    ) {
      for (const subject of offer.subjects) {
        const requiredSubjectFields = [
          "subjectId",
          "subjectName",
          "levelId",
          "levelName",
        ];
        for (const field of requiredSubjectFields) {
          if (!subject.hasOwnProperty(field) || !field) {
            reactToast("error", "Please fill all required fields.");
            return false; // Missing required field in subject
          }
        }
      }
    }

    return true; // All validations passed
  };

  const getLevelsBySubjectId = (subjectId) => {
    const subject = teacherCourses?.data?.find(
      (subject) => subject.subjectId === parseInt(subjectId)
    );
    return subject ? subject?.courseOfferingLevels : [];
  };

  const handleSelection = (type) => {
    handleResetState();
    setOfferDetail((prev) => ({
      ...prev,
      offerType: type,
    }));
  };

  const haddleSendOffer = async () => {
    try {
      let payload = {
        ...offerDetail,
        price: Number(price),
        startDate: new Date(startDate).toISOString(),
        endDate: new Date(endDate).toISOString(),
        slots: selectedSlots,
        subjects: selectedSubjects,
        extraSubjects: temporarySubjectsList,
        teachingMode,
        description: offerDesc ?? null,
        instantOffer: isInstantOffer,
        offerType: isInstantOffer ? "instant" : offerDetail?.offerType,
      };
      // console.log("payload", payload);
      debugger;
      let validate = validateOffer(payload);
      if (!validate) {
        //toast.error("Please select all fields!");
        return;
      }
      setOfferRequestLoading(true);

      setOfferDetail((prev) => ({
        ...prev,
        ...payload,
      }));
      // console.log("payload", payload);
      debugger;
      const { status, data } = await createOfferRequest({
        ...payload,
        teacherId,
        studentId,
      });
      if (status === 201) {
        reactToast("success", data?.message);
        await onSendOffer({ ...payload, offerId: data?.data?.offerId });
      } else {
        reactToast("error", data?.message);
      }
      setOfferRequestLoading(false);
      setIsInstantOffer(false);
    } catch (error) {
      setOfferRequestLoading(false);
    }
  };

  const handleSubjectChange = (subjectId) => {
    setCourse(subjectId);

    const matchedSubject = teacherCourses?.data?.find(
      (item) => item?.subjectId === subjectId
    );

    const alreadyExists = selectedSubjects?.find(
      (item) => item?.subjectId === subjectId
    );

    if (alreadyExists) {
      toast.error(`${alreadyExists?.subjectName} already exists!`);
      return;
    }

    const newSubject = {
      subjectId,
      subjectName: matchedSubject?.subjectName,
      levelId: "",
      levelName: "",
    };

    setSelectedSubjects([...selectedSubjects, newSubject]);
  };

  const handleMoreSubjecs = (e) => {
    const subjectId = e;
    setNewTemporarySubject(subjectId);
    let matchedSubject = allSubjects?.find(
      (item) => item?.id === parseInt(subjectId)
    );
    let alradyExits = temporarySubjectsList?.find(
      (item) => parseInt(item?.subjectId) === parseInt(subjectId)
    );
    if (alradyExits) {
      toast.error(`${alradyExits?.subjectName} already exits!`);
      return;
    }
    const newSubject = {
      subjectId,
      subjectName: matchedSubject?.name,
    };
    setTemporarySubjectsList([...temporarySubjectsList, newSubject]);
  };

  const handleSubjectLevel = (subject, val) => {
    let value = val;
    const levelName = findLevelName(subject, value);

    const updatedSubjects = selectedSubjects.map((item) =>
      item.subjectId === subject.subjectId
        ? { ...item, levelName, levelId: value }
        : item
    );
    setSelectedSubjects(updatedSubjects);
  };

  const findLevelName = (subject, levelId) => {
    const matchedSubject = teacherCourses?.data?.find(
      (ele) => ele.subjectId === parseInt(subject?.subjectId)
    );
    const matchedLevel = matchedSubject?.courseOfferingLevels?.find(
      (level) => level.id === parseInt(levelId)
    );
    return matchedLevel ? matchedLevel.name : "";
  };

  const removeSelectedSubject = (subject) => {
    setCourse("");
    const updatedSubjects = selectedSubjects.filter(
      (item) => item.subjectId !== subject.subjectId
    );
    setSelectedSubjects(updatedSubjects);
  };

  const handleDateChange = (selectedDate, fieldName = "date") => {
    if (!selectedDate) return;

    const selectedDateISO = selectedDate.format("YYYY-MM-DD");

    // Important change: Instead of converting to UTC, we preserve the local date
    // by creating a UTC date with the SAME calendar date
    const parsedDate = DateTime.fromISO(selectedDateISO);
    const utcDate = DateTime.utc(
      parsedDate.year,
      parsedDate.month,
      parsedDate.day,
      12
    ).toISODate();

    setSlots([]);
    setSelectedSlots([]);
    setEndDate("");

    if (fieldName === "startDate" || fieldName === "date") {
      setStartDate(utcDate);

      if (
        offerDetail?.offerType === SESSION_TYPE ||
        offerDetail?.offerType === DEMO_TYPE ||
        offerDetail?.offerType === RETAKE_TYPE
      ) {
        setEndDate(utcDate);
      }
    } else {
      setEndDate(utcDate);
    }
  };

  const handleDeleteTemporartSubject = (subjectId) => {
    const updatedList = [...temporarySubjectsList];
    let filter = updatedList?.filter(
      (item) => Number(item?.subjectId) !== Number(subjectId)
    );
    setTemporarySubjectsList(filter);
  };
  const handleTeachingMode = (e) => {
    let value = e.target.value;
    // console.log(value);
    debugger;
    handleResetState();
    setTeachingMode(value);
  };

  const options = [
    { label: "Online", value: TEACHING_MODE.ONLINE },
    { label: "Home", value: TEACHING_MODE.HOME },
  ];

  const renderDateValueInUtc = (valueToFormat) => {
    if (!valueToFormat) return null;
    const utcDate = DateTime.fromISO(valueToFormat, {
      zone: "utc",
    });
    return DateTime.local(utcDate.year, utcDate.month, utcDate.day).toISODate();
  };

  return (
    <Modal
      maskClosable={false}
      footer={null}
      closable
      title={
        <Title level={4} className="poppins">
          {offerDetail?.offerType === DEMO_TYPE
            ? "Create Demo"
            : isInstantOffer
            ? "Create Instant Offer"
            : "Create Offer"}
        </Title>
      }
      open={open}
      onOk={handleOk}
      onCancel={handleCloseModal}
      width={800}
      {...rest}
    >
      <div className="pe-2">
        <div className="row p-0 mt-3">
          <div className="col-md-12 col-md-12 col-12 h-100">
            <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-start align-items-md-center flex-wrap gap-2 gap-md-3">
              <div className="d-flex flex-row align-items-center flex-wrap gap-2 me-md-4">
                <Title className="fw-light poppins mb-0 text-nowrap fs-15">
                  Teaching Mode:
                </Title>
                <Radio.Group
                  options={options}
                  defaultValue="online"
                  onChange={handleTeachingMode}
                  value={teachingMode}
                />
              </div>

              {offerDetail?.offerType !== DEMO_TYPE &&
                offerDetail?.offerType !== RETAKE_TYPE && (
                  <div className="d-flex flex-row align-items-center gap-2">
                    {teachingMode !== TEACHING_MODE.HOME && (
                      <button
                        onClick={() => handleSelection(SESSION_TYPE)}
                        className={`btn btn-outlined px-3 py-1 fs_12 ${
                          offerDetail?.offerType === SESSION_TYPE &&
                          "btn-contained"
                        }`}
                      >
                        Session
                      </button>
                    )}
                    <button
                      onClick={() => handleSelection(MONTHLY_TYPE)}
                      className={`btn btn-outlined px-3 py-1 fs_12 ${
                        offerDetail?.offerType === MONTHLY_TYPE &&
                        "btn-contained"
                      }`}
                      type="button"
                    >
                      Monthly
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="row p-0 mt-md-4 mt-3">
          <div className="col-md-12 col-12 d-flex flex-column flex-md-row justify-content-center align-items-stretch align-items-md-center gap-2 gap-md-2 gap-lg-3">
            {(offerDetail?.offerType === SESSION_TYPE ||
              offerDetail?.offerType === DEMO_TYPE ||
              offerDetail?.offerType === RETAKE_TYPE) && (
              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100">
                <Title className="fw-light poppins mb-2 mb-md-0 me-md-2 text-nowrap fs-14">
                  Date
                </Title>
                <DatePicker
                  className="w-100"
                  value={
                    startDate ? dayjs(renderDateValueInUtc(startDate)) : null
                  }
                  onChange={(date) => handleDateChange(date, "date")}
                  disabledDate={(current) =>
                    current && current < dayjs().startOf("day")
                  }
                />
              </div>
            )}

            {offerDetail?.offerType === MONTHLY_TYPE && (
              <>
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100">
                  <Title className="fw-light poppins mb-2 mb-md-0 me-md-2 text-nowrap fs-14">
                    From:
                  </Title>
                  <DatePicker
                    className="w-100"
                    value={
                      startDate ? dayjs(renderDateValueInUtc(startDate)) : null
                    }
                    onChange={(date) => handleDateChange(date, "startDate")}
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                  />
                </div>

                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100">
                  <Title className="fw-light poppins mb-2 mb-md-0 me-md-2 text-nowrap fs-14">
                    To:
                  </Title>
                  <DatePicker
                    className="w-100"
                    value={
                      endDate ? dayjs(renderDateValueInUtc(endDate)) : null
                    }
                    onChange={(date) => handleDateChange(date, "endDate")}
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                  />
                </div>
              </>
            )}

            <button
              disabled={loading}
              onClick={handleSearchSlots}
              type="button"
              className="btn btn-contained mt-2 mt-md-0 px-3 py-2 fs_12"
              style={{ minWidth: "110px" }}
            >
              Search Slots
            </button>
          </div>
        </div>

        <div className="row p-0 mt-3 mt-md-4">
          <div className="col-lg-12 col-md-12 col-12">
            <TeacherSlots
              onCheckAllSameDaySlots={matchedAllSlotsLength}
              offerDetail={offerDetail}
              loading={loading}
              slots={slots}
              onSelect={handleSlots}
              selectedSlots={selectedSlots}
              onSelectSameSlots={handleBookAllSlotsForSameDay}
            />
          </div>
        </div>

        {offerDetail?.offerType !== DEMO_TYPE &&
          offerDetail?.offerType !== RETAKE_TYPE && (
            <>
              <div className="row mt-md-4 mt-3">
                <div className="col-lg-6 col-md-6 col-12 gap-2 gap-md-2 gap-lg-3">
                  <div className="d-flex flex-column justify-content-start align-items-start w-100">
                    <div className="d-flex flex-column w-100">
                      <Title className="fw-light poppins mb-1 text-nowrap fs-14">
                        Subject
                      </Title>
                      <Select
                        showSearch
                        className="w-100"
                        style={{ width: "100%" }}
                        placeholder="Select a Subject"
                        optionFilterProp="label"
                        value={course || ""}
                        onChange={handleSubjectChange}
                        options={teacherCourses?.data?.map((x) => ({
                          label: x?.subjectName,
                          value: x?.subjectId,
                        }))}
                      />
                    </div>
                    <div className="d-flex flex-wrap w-100 gap-2 mt-2">
                      {selectedSubjects?.map((subject, index) => (
                        <div
                          key={index}
                          className="d-flex flex-column p-2 text-black"
                          style={{
                            // backgroundColor: "#f5f5f5",
                            borderRadius: "8px",
                            border: "1px solid rgb(214, 210, 210)",
                            minWidth: "150px",
                            maxWidth: "200px",
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-start w-100">
                            <span className="fs_12">{subject.subjectName}</span>
                            <MdCancel
                              size={14}
                              style={{ marginLeft: "5px", cursor: "pointer" }}
                              onClick={() => removeSelectedSubject(subject)}
                            />
                          </div>

                          <Select
                            placeholder="Select level"
                            className="mt-2 fs_12"
                            value={subject.levelId || ""}
                            onChange={(value) =>
                              handleSubjectLevel(subject, value)
                            }
                            options={getLevelsBySubjectId(
                              subject?.subjectId
                            ).map((level) => ({
                              label: level.name,
                              value: level.id,
                            }))}
                            size="small"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-12">
                  <div className="d-flex flex-column justify-content-start align-items-start w-100">
                    <div className="d-flex flex-column w-100">
                      <Title className="fw-light poppins mb-1 text-nowrap fs-14">
                        Add more subjects
                      </Title>
                      <Select
                        showSearch
                        style={{
                          width: "100%",
                        }}
                        placeholder="Select more subjects"
                        optionFilterProp="label"
                        onChange={handleMoreSubjecs}
                        options={allSubjects?.map((x) => ({
                          label: x?.name,
                          value: x?.id,
                        }))}
                      />
                    </div>
                    <div className="d-flex flex-wrap w-100 gap-2 mt-2">
                      {temporarySubjectsList?.map((subject, index) => (
                        <Tag
                          key={index}
                          closable
                          onClose={() =>
                            handleDeleteTemporartSubject(subject?.subjectId)
                          }
                          className="poppins fs_12 d-flex align-items-center"
                          color="cyan"
                        >
                          {subject?.subjectName}
                        </Tag>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-md-3 mt-2">
                <div className="col-lg-6 col-md-6 col-12 ">
                  <div className="d-flex flex-column w-100">
                    <Title className="fw-light poppins mb-1 text-nowrap fs-14">
                      Price
                    </Title>
                    <Input
                      type="number"
                      value={price || ""}
                      onChange={(e) => setPrice(e.target.value)}
                      placeholder="0"
                      min={10}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-lg-0 mt-1">
                  <div className="d-flex flex-column w-100">
                    <Title className="fw-light poppins mb-1 text-nowrap fs-14">
                      Description
                    </Title>
                    <Input.TextArea
                      value={offerDesc || ""}
                      onChange={(e) => setOfferDesc(e.target.value)}
                      placeholder="Enter your offer details..."
                      rows={4}
                      className="poppins"
                    />
                  </div>
                </div>
              </div>
            </>
          )}

        <hr />

        {offerDetail?.offerType === DEMO_TYPE && (
          <>
            <div className="row mt-md-3 mt-2">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="d-flex flex-column justify-content-between h-100">
                  <div className="mb-3">
                    <Checkbox
                      onChange={(e) => setIsInstantOffer(e.target.checked)}
                    >
                      Instant offer
                    </Checkbox>
                  </div>

                  {isInstantOffer && (
                    <div>
                      <Title className="fw-light poppins mb-1 text-nowrap fs-14">
                        Price *
                      </Title>
                      <Input
                        type="number"
                        disabled={!isInstantOffer}
                        value={price || ""}
                        onChange={(e) => setPrice(e.target.value)}
                        placeholder="0"
                        min={10}
                        required
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isInstantOffer && (
              <div className="row mt-md-3 mt-2">
                <div className="col-lg-12 col-md-12 col-12 mt-md-0 mt-lg-0 mt-1">
                  <div className="d-flex flex-column w-100">
                    <Title className="fw-light poppins mb-1 text-nowrap fs-14">
                      Description *
                    </Title>
                    <Input.TextArea
                      value={offerDesc || ""}
                      disabled={!isInstantOffer}
                      onChange={(e) => setOfferDesc(e.target.value)}
                      placeholder="Enter your offer details..."
                      rows={4}
                      className="poppins"
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {loggedInUser?.id ? (
        <div className="d-flex justify-content-end pe-2 mt-4">
          <button
            disabled={offerRequestLoading}
            onClick={handleCloseModal}
            type="button"
            className="btn btn-outlined btn-sm me-2 px-3 py-1 fs_12"
          >
            Cancel
          </button>
          {offerDetail?.offerType === MONTHLY_TYPE && (
            <button
              type="button"
              className="btn btn-contained me-2 px-3 py-1 fs_12"
              onClick={handleRedirectionToWallet}
            >
              Topup
            </button>
          )}
          <button
            disabled={offerRequestLoading || !loggedInUser?.id}
            onClick={haddleSendOffer}
            type="button"
            className="btn btn-contained px-3 py-1 fs_12"
          >
            {offerRequestLoading ? (
              <Loader />
            ) : (
              `${
                offerDetail?.offerType === DEMO_TYPE
                  ? "Schedule Demo"
                  : "Send offer"
              }`
            )}
          </button>
        </div>
      ) : (
        <div className={styles.blockMessage}>
          <p>Please login to schedule demo.</p>
        </div>
      )}
    </Modal>
  );
};

export default CreateOfferCard;
